<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="客户管理" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <el-form
              class="jc-table-actionBar-item"
              :inline="true"
              :model="form"
            >
              <el-form-item label="PIN：">
                <el-input v-model.trim="form.customerPin"></el-input>
              </el-form-item>

              <el-form-item label="账号名：">
                <el-input v-model.trim="form.loginName"></el-input>
              </el-form-item>

              <el-form-item label="关联时间：">
                <el-date-picker
                  v-model="daterange"
                  type="daterange"
                  placeholder="选择日期范围"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label="账户类型：">
                <el-select
                  v-model="form.accountType"
                  placeholder="请选择"
                  clearable
                  @change="query"
                  class="accountSelect"
                >
                  <el-option
                    v-for="item in ACCOUNT_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="客户名称：" style="margin-left: 0px">
                <el-input v-model.trim="form.nameLike"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="query(query)">查询</el-button>
              </el-form-item>

              <el-form-item>
                <el-button @click="exportList" class="jc-button-icon">
                  <i class="jc-icon-download"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column prop="pin" label="PIN">
              <template slot-scope="scope">{{
                scope.row.pin | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="loginName" label="账号名">
              <template slot-scope="scope">{{
                scope.row.loginName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="realName" label="实名认证">
              <template slot-scope="scope">{{
                scope.row.realName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="accountTypeName" label="账户类型">
              <template slot-scope="scope">{{
                scope.row.accountTypeName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="name" label="客户名称">
              <template slot-scope="scope">{{
                scope.row.name | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="tel" label="联系电话" width="110">
              <template slot-scope="scope">{{
                scope.row.tel | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="email" label="邮箱">
              <template slot-scope="scope">{{
                scope.row.email | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="relTime" label="关联时间" width="150px">
              <template slot-scope="scope">{{
                scope.row.relTime | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">{{
                scope.row.remark | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="openDetail(scope.row)"
                  >详情</el-button
                >
                <el-button type="text" @click="unbind(scope.row.pin)"
                  >解除绑定</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="jc-container-table-actionBar" v-if="total > 10">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageIndex"
              :page-sizes="[10, 20, 50]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail :instance="instance" ref="detailRef" @success="query" />
  </div>
</template>

<script>
import {
  queryMyCustomerList,
  exportMyCustomerList,
  unbundlingCust,
} from '@/api/distributor-api.js'
import { getDate } from '@/utils'
import routerMixins from '@/mixins/router-mixins.js'
import { ACCOUNT_TYPE } from '@/utils/constant'
import Detail from '@/views/client/Detail.vue'
export default {
  components: { Detail },
  mixins: [routerMixins],
  data() {
    return {
      dialogVisible: false,
      currentPage1: 1,
      ACCOUNT_TYPE,
      instance: {},
      form: {
        customerPin: '',
        pageSize: 10,
        pageIndex: 1,
        accountType: '',
        startRelTime: '',
        endRelTime: '',
        loginName: '',
        nameLike: '',
      },
      daterange: '',
      total: 0,
      tableData: [],
    }
  },
  watch: {
    daterange(curVal) {
      this.form.startRelTime =
        (curVal[0] && getDate(curVal[0]).txt_ymd + ' 00:00:00') || ''
      this.form.endRelTime =
        (curVal[1] && getDate(curVal[1]).txt_ymd + ' 23:59:59') || ''
    },
  },
  activated() {
    this.query()
  },
  methods: {
    openDetail(row) {
      this.instance = row
      this.$refs.detailRef.open()
    },
    handleSizeChange(val) {
      this.form.pageSize = val
      this.query()
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val
      this.query()
    },
    async query(query) {
      if (query) {
        this.form.pageIndex = 1
      }
      try {
        let { result } = await queryMyCustomerList(this.form)
        this.tableData = result && result.result
        this.total =
          result && result.pagination && result.pagination.numberRecords
      } catch (e) {
        console.log(e)
        this.tableData = []
        this.total = 0
      }
    },
    async exportList() {
      try {
        let { result } = await exportMyCustomerList(this.form)
        window.location.href = eval("'" + result.uri + "'")
      } catch (e) {
        console.log(e)
      }
    },
    unbind(pin) {
      this.$jcconfirm(
        `如您解除与该客户的关联关系，该客户的消费将不计入您的业绩！确认解除与账户为${pin}的关联关系吗？`,
        '解除客户关联',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).then(async () => {
        try {
          let { result } = await unbundlingCust({
            pin,
          })
          if (result && result.result) {
            this.$jcNotify({
              type: 'success',
              message: `您已成功解除与客户账户为${pin}的客户的关联关系`,
            })
          } else {
            this.$jcNotify({
              type: 'error',
              message: '该客户的消费已计入您的业绩，暂时不支持解绑操作。',
            })
          }
        } finally {
          this.query()
        }
      })
    },
  },
}
</script>

<style scoped="true">
.jc-container-table-actionBar >>> .jc-table-actionBar-item {
  margin-right: 0px;
}
.jc-table-actionBar-item >>> .jc-input {
  width: 140px;
}
.accountSelect >>> .jc-input {
  width: 90px;
}
</style>
